import Typography from "@mui/material/Typography";
import { FilterChip } from "../FilterChip";
import React, { useCallback } from "react";
import { CountryInput } from "./CountryInput";
import { formatCountLabel } from "../../../utils/text";

interface CountriesFilterChipProps {
  selectedCountries: string[];
  onCountriesChange: (countries: string[]) => void;
  placeholderText?: string;
  id?: string;
}

export const CountriesFilterChip: React.FC<CountriesFilterChipProps> = ({
  selectedCountries,
  onCountriesChange,
  placeholderText = "Select Countries",
  id = "countries",
}) => {
  const getSelectedCount = useCallback(() => {
    return selectedCountries.length;
  }, [selectedCountries]);

  const handleCountrySelect = useCallback(
    (countries: string[]) => {
      onCountriesChange(countries);
    },
    [onCountriesChange]
  );

  return (
    <FilterChip
      id={id}
      label="Country"
      getSelectedCount={getSelectedCount}
      popoverOptions={{ title: "Countries", disableActionButtons: true }}
      renderLabel={(label, count) => (
        <Typography component="span" color="textSecondary">
          {formatCountLabel(label, count)}
        </Typography>
      )}
    >
      <CountryInput
        selectedItems={selectedCountries}
        onCountrySelect={handleCountrySelect}
        placeholderText={placeholderText}
      />
    </FilterChip>
  );
};
